let addToastGlobal = null;

export const registerGlobalToast = (fn) => {
  addToastGlobal = fn;
};

export const showGlobalToast = (message, type = "info", duration = 2000, options = {}) => {
  if (addToastGlobal) {
    addToastGlobal(message, type, duration, options);
  } else {
    console.warn("Toast not ready yet");
  }
};
